import { Injectable } from '@angular/core';

import { registerLocaleData } from '@angular/common';

import localeEN from '@angular/common/locales/en';
import localeDE from '@angular/common/locales/de';

/*
 * Initialisierungen, die für alle HIS Angualar-Apps einheitlich sein sollen
 */
@Injectable({providedIn: 'root'})
export class HisCoreInitializerService {

    constructor() {
    }

    /*
     * Zusätzlich zu en_us weitere Locales registrieren, die z.B. für die DatePipe verfügbar sein sollen
     */
    initializeLocaleData() {
        return new Promise( ( resolve, reject ) => {
            registerLocaleData( localeEN, 'en' );
            registerLocaleData( localeDE, 'de' );
            resolve( true );
        } );
    }
}
